"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var SearchResultBarContent_1 = __importDefault(require("./SearchResultBarContent"));
var SearchResultBar = /** @class */ (function (_super) {
    __extends(SearchResultBar, _super);
    // static fragments = {
    //   viewer: gql`
    //     fragment SearchResultBar_viewer on Viewer
    //       @argumentDefinitions(params: { type: "String" }) {
    //       ...SearchResultBarContent_viewer @arguments(params: $params)
    //     }
    //   `,
    // };
    function SearchResultBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            margin: undefined,
        };
        return _this;
    }
    SearchResultBar.prototype.handleOverflowChange = function (isOverflowed) {
        if (isOverflowed) {
            this.setState({
                margin: '0 -14px',
            });
        }
        else {
            this.setState({
                margin: undefined,
            });
        }
    };
    SearchResultBar.prototype.render = function () {
        return (react_1.default.createElement("div", { style: { position: 'relative' } },
            react_1.default.createElement("div", { style: {
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    opacity: '0',
                    width: '100%',
                    zIndex: -1,
                } },
                react_1.default.createElement(SearchResultBarContent_1.default, { viewer: this.props.viewer, onOverflowChange: this.handleOverflowChange.bind(this) })),
            react_1.default.createElement(SearchResultBarContent_1.default, { viewer: this.props.viewer, margin: this.state.margin })));
    };
    SearchResultBar.propTypes = {
        viewer: prop_types_1.default.shape({
            searchModel: prop_types_1.default.shape({
                count: prop_types_1.default.number,
            }),
            searchItem: prop_types_1.default.shape({
                count: prop_types_1.default.number,
            }),
            searchCatalog: prop_types_1.default.shape({
                count: prop_types_1.default.number,
            }),
        }),
    };
    return SearchResultBar;
}(react_1.default.Component));
exports.default = SearchResultBar;
// export default createFragmentContainer(SearchResultBar, {
//   viewer: graphql`
//     fragment SearchResultBar_viewer on Viewer
//       @argumentDefinitions(params: { type: "String" }) {
//       ...SearchResultBarContent_viewer @arguments(params: $params)
//     }
//   `,
// });
